import React from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

import { usePractitionersAdmin } from 'lib/hooks/queries/practitioners/usePractitionersAdmin';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import columns from './configs/columns';
import DEFAULT_FILTERS from './configs/defaultFilters';
import HeaderActions from './lib/HeaderActions';

const PractitionersTable = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { pathname } = useLocation();

  const newPathExists = pathname.includes('new');

  const onRowClicked = (event) => {
    if (event?.id) {
      navigate(`/admin/practitioners/${event?.id}`);
    }
  };

  if (id || newPathExists) return <Outlet />;

  return (
    <AgTablePage
      onSelectRow={onRowClicked}
      rightHeaderActions={HeaderActions}
      defaultColumns={columns}
      defaultFilters={DEFAULT_FILTERS}
      useData={usePractitionersAdmin}
      name="practitioner"
      keepOldFilters
    />
  );
};

export default withErrorBoundary(PractitionersTable);
